// Popover panel with Department + Rank dropdown filters for crew table
import React, { useRef, useEffect } from 'react';

const CrewFilterPopover = ({
  onClose,
  filters,
  onFilterChange,
  onClearFilters,
  departments = [],
  designations = [],
}) => {
  const popoverRef = useRef(null);

  // Close on click outside (delay listener to avoid conflict with toggle button)
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        // Skip if click target is the filter toggle button (parent handles toggle)
        if (e.target.closest('[data-filter-toggle]')) return;
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const activeFilterCount = Object.values(filters).filter(Boolean).length;

  const selectClass =
    'tw-w-full tw-px-2 tw-py-1.5 tw-border tw-border-gray-300 tw-rounded tw-text-sm tw-bg-white tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500 tw-appearance-none tw-cursor-pointer';

  return (
    <div
      ref={popoverRef}
      className="tw-absolute tw-right-0 tw-top-full tw-mt-2 tw-w-72 tw-bg-white tw-rounded-lg tw-shadow-xl tw-border tw-border-gray-200 tw-z-50 tw-p-4 tw-animate-in tw-fade-in tw-zoom-in-95 tw-duration-100"
      style={{ animation: 'fadeInScale 100ms ease-out' }}
    >
      {/* Header with inline Clear All */}
      <div className="tw-flex tw-items-center tw-justify-between tw-mb-4">
        <h3 className="tw-text-sm tw-font-semibold tw-text-gray-900">Filter Crew</h3>
        {activeFilterCount > 0 && (
          <button
            onClick={onClearFilters}
            className="tw-text-xs tw-text-indigo-600 hover:tw-underline tw-cursor-pointer tw-transition-colors"
          >
            Clear All
          </button>
        )}
      </div>

      <div className="tw-space-y-3">
        {/* Department dropdown */}
        <div className="tw-space-y-1">
          <label className="tw-text-xs tw-font-medium tw-text-gray-700">
            Department
          </label>
          <select
            value={filters.department}
            onChange={(e) => onFilterChange('department', e.target.value)}
            className={selectClass}
          >
            <option value="">All Departments</option>
            {departments.map((dept) => (
              <option key={dept._id} value={dept._id}>
                {dept.name}
              </option>
            ))}
          </select>
        </div>

        {/* Rank dropdown */}
        <div className="tw-space-y-1">
          <label className="tw-text-xs tw-font-medium tw-text-gray-700">
            Rank
          </label>
          <select
            value={filters.designation}
            onChange={(e) => onFilterChange('designation', e.target.value)}
            className={selectClass}
          >
            <option value="">All Ranks</option>
            {designations.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default CrewFilterPopover;
